<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-man`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41 5a2 2 0 012 2v9a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4.172l-6.36 6.36A15.931 15.931 0 0136 28c0 8.837-7.163 16-16 16S4 36.837 4 28s7.163-16 16-16c3.697 0 7.102 1.254 9.811 3.36L36.171 9H32a1 1 0 01-1-1V6a1 1 0 011-1h9zM20 16c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z"/></svg>
</template>
<script>

export default {
  name: 'IconMan',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
